import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'tactics-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <circle
                    class="svgWrapperShape"
                    id="cg-path-1"
                    cx="53"
                    cy="53"
                    r="53"
                />
                <polygon
                    id="cg-path-3"
                    points="0.00216923077 0.00388786765 17.3567385 0.00388786765 17.3567385 17.2782598 0.00216923077 17.2782598"
                />
            </defs>
            <g
                id="cg-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="cg-B-Person-page--more-people-added-"
                    transform="translate(-945.000000, -2382.000000)"
                >
                    <g
                        id="cg-Group-29"
                        transform="translate(948.000000, 2385.000000)"
                    >
                        <g id="cg-Group-24">
                            <g id="cg-Screen-Shot-2019-01-14-at-5.33.33-PM">
                                <mask id="cg-mask-2" fill="white">
                                    <use xlink:href="#cg-path-1" />
                                </mask>
                                <use
                                    id="cg-Mask"
                                    stroke="#0092C8"
                                    stroke-width="4.4"
                                    fill="#F3FBFE"
                                    fill-rule="nonzero"
                                    xlink:href="#cg-path-1"
                                />
                            </g>
                            <g
                                id="cg-Group-8"
                                transform="translate(27.000000, 29.000000)"
                            >
                                <path
                                    d="M10.1230769,2.87990196 C14.1086769,2.87990196 17.3538462,6.11115196 17.3538462,10.0796569 C17.3538462,14.0481618 14.1086769,17.2794118 10.1230769,17.2794118 C6.13747692,17.2794118 2.89230769,14.0481618 2.89230769,10.0796569 C2.89230769,6.11115196 6.13747692,2.87990196 10.1230769,2.87990196 M10.1230769,20.1593137 C15.7052308,20.1593137 20.2461538,15.6378676 20.2461538,10.0796569 C20.2461538,4.52144608 15.7052308,0 10.1230769,0 C4.54092308,0 0,4.52144608 0,10.0796569 C0,15.6378676 4.54092308,20.1593137 10.1230769,20.1593137"
                                    id="cg-Fill-1"
                                    fill="#3D1C70"
                                />
                                <path
                                    d="M34.9255539,8.58319982 L41.9384615,8.58319982 L33.2519533,0 L24.5654452,8.58319982 L31.5783528,8.58319982 C31.5783528,11.1324102 30.8544771,13.8532845 29.4820088,16.4454108 C28.07769,19.1033417 25.987137,21.6353857 23.4390946,23.7754635 C17.6944172,28.5963607 9.96342489,31.2514305 1.67649608,31.2514305 C0.75283071,31.2514305 0,31.9924468 0,32.902266 C0,33.8178073 0.75283071,34.5588235 1.67649608,34.5588235 C10.7567926,34.5588235 19.2579887,31.6262303 25.6078261,26.2989242 C28.4801649,23.8870451 30.8486861,21.0116732 32.4527946,17.9818036 C34.0742761,14.9176013 34.9313449,11.6702907 34.9313449,8.58606088 L34.9255539,8.58319982 Z"
                                    id="cg-Fill-3"
                                    fill="#3D1C70"
                                />
                                <g
                                    id="cg-Group-7"
                                    transform="translate(28.923077, 28.799020)"
                                >
                                    <mask id="cg-mask-4" fill="white">
                                        <use xlink:href="#cg-path-3" />
                                    </mask>
                                    <g id="cg-Clip-6" />
                                    <path
                                        d="M10.7217846,8.64143382 L16.9286769,2.46116422 C17.4926769,1.89958333 17.4926769,0.989534314 16.9286769,0.425073529 C16.3646769,-0.136507353 15.4478154,-0.136507353 14.8838154,0.425073529 L8.67692308,6.60534314 L2.46713846,0.425073529 C1.90603077,-0.136507353 0.989169231,-0.136507353 0.425169231,0.425073529 C-0.138830769,0.989534314 -0.138830769,1.89958333 0.425169231,2.46116422 L6.63206154,8.64143382 L0.425169231,14.8217034 C-0.138830769,15.3861642 -0.138830769,16.2962132 0.425169231,16.860674 C0.708615385,17.1400245 1.07883077,17.2782598 1.44904615,17.2782598 C1.81926154,17.2782598 2.18947692,17.1371446 2.47292308,16.860674 L8.67981538,10.6775245 L14.8867077,16.860674 C15.1701538,17.1400245 15.5403692,17.2782598 15.9105846,17.2782598 C16.2808,17.2782598 16.6510154,17.1371446 16.9344615,16.860674 C17.4984615,16.2962132 17.4984615,15.3861642 16.9344615,14.8217034 L10.7275692,8.64143382 L10.7217846,8.64143382 Z"
                                        id="cg-Fill-5"
                                        fill="#3D1C70"
                                        mask="url(#cg-mask-4)"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class TacticsIconComponent {
    @Input()
    iconSize: IconSize;
}
